import DOMPurify from "dompurify";

export const HtmlPurifyText = text => {
  return DOMPurify.sanitize(text);
};
